import { render } from "./CouriersPage.vue?vue&type=template&id=cbe82348"
import script from "./CouriersPage.vue?vue&type=script&lang=js"
export * from "./CouriersPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__